import { buildPublicRouteClassifier } from './public-route-classifier-registry.ts';

const classifierModules = import.meta.glob(
  '../../plugins/**/p-*/offer-to-public-route-classifier.ts',
  { eager: true },
);

export const isPublicPluginPath = buildPublicRouteClassifier(classifierModules);
